import { render, staticRenderFns } from "./FontPairingIndex.vue?vue&type=template&id=2d89a5ba"
import script from "./FontPairingIndex.vue?vue&type=script&lang=js"
export * from "./FontPairingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports